'use client';

import { Lock } from 'lucide-react';
import Image from '~/components/common/Image';
import { appAssetsCdnUrl } from '~/constants/environment';
import { useSemTitle } from '~/context/flp/GlobalContext';
import {
  Copy,
  CopyContainer,
  CopyHeading,
  CopyStrong,
  CopyText,
  Footnote,
  GraphicContainer,
  HeroContentContainer,
  Label,
  MonthlyPayment,
  Payment,
  Price,
  VehicleContainer
} from './Hero.styles';
import HeroCTA from './HeroCta';

export default function HeroContent() {
  const semTitle = useSemTitle();
  const title = semTitle ?? 'FINANCING FOR EVERYONE';
  const isSemTitle = Boolean(semTitle);
  const [titleFirst, titleRest] = isSemTitle
    ? title
        .toUpperCase()
        .split(/\.\s+/, 2)
        .map((s, i, arr) => (i === 0 && arr.length > 1 ? `${s}.` : s))
    : [title, undefined];

  return (
    <HeroContentContainer>
      <GraphicContainer>
        <Price>
          <Label>Monthly Payment*</Label>
          <Payment>
            <Lock
              className="size-xl shrink-0 sm:size-[21px] md:size-2xl lg:size-3xl"
              color="white"
              size={32}
            />
            <MonthlyPayment>
              <span>$395</span>
              <span className="t-strong-md sm:t-heading-lg md:t-heading-md lg:t-heading-xl">
                /mo
              </span>
            </MonthlyPayment>
          </Payment>
        </Price>
        <VehicleContainer>
          <Image
            className="absolute right-1/2 top-[54px] m-auto h-auto w-[323px] translate-x-[44%] sm:right-[-90px] sm:top-[105px] sm:min-w-[480px] sm:translate-x-0 md:right-[-60px] md:top-[95px] md:min-w-[575px] lg:right-[-55px] lg:top-[67px] lg:min-w-[675px] xl:right-[-63px] xl:top-[74px] xl:min-w-[670px]"
            src={`${appAssetsCdnUrl}/images/flp/hero-sedan.png`}
            alt="vehicle"
          />
        </VehicleContainer>
        <Footnote>
          *All sample rates based on a well-qualified buyer with an APR of 6.99%
          at 75 months with $0 down payment.
        </Footnote>
      </GraphicContainer>
      <CopyContainer>
        <Copy>
          <CopyHeading>
            {titleFirst}
            {titleRest && (
              <>
                <br />
                {titleRest}
              </>
            )}
          </CopyHeading>
          <CopyText>
            Get pre-qualified for an auto loan in minutes.{' '}
            <CopyStrong>No hit to your credit.</CopyStrong>
          </CopyText>
        </Copy>
        <HeroCTA />
      </CopyContainer>
    </HeroContentContainer>
  );
}
